import { useState } from "react";
import { useFormik } from "formik";
import { Link, Redirect } from "react-router-dom";
import { sendMail } from "../_redux/authCrud";

const initialValues = {
  email: ""
};

export default function ForgotPassword(props) {
  const { intl } = props;
  const { authData } = props;
  const [isRequested, setIsRequested] = useState(false);
  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    // validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { setValues, setStatus, setSubmitting }) => {
      const loginData = {
        domain: authData.domain,
        authId: authData.authId,
        email: values.email
      };
      sendMail(loginData)
      .then(({ data: {
        isSuccess,
        type,
        message
      }}) => {
          if (type === "error") type = "danger";            
          setValues(type);
          setStatus(message);
          setSubmitting(false);
          if (isSuccess) setTimeout(() => setIsRequested(true), 6000);
      })
      .catch(() => {
          setIsRequested(false);
          setSubmitting(false);
          setStatus(
            intl.formatMessage(
              { id: "AUTH.VALIDATION.NOT_FOUND" },
              { name: values.email }
            )
          );
      });
    }
  });

  return (
    <>
      {isRequested && <Redirect to="/auth" />}
      {!isRequested && (
        <div className="login-form login-forgot" style={{ display: "block" }}>
          <div className="text-center mb-10 mb-lg-20">
            <h3 className="font-size-h1">
              {authData.schoolName}
            </h3>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          >
            {formik.status ? (
              <div className={`mb-10 alert alert-custom alert-light-${formik.values} alert-dismissible`}>
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            ) : (
              <div className="mb-10 alert alert-custom alert-light-info alert-dismissible">
                <div className="alert-text ">
                  Kullanıcı bilgilerinizi hatırlamıyorsanız, bilgilerinizi yenilemek için <strong>sistemde kayıtlı email adresinizi</strong> giriniz.
                </div>
              </div>
            )}
            <div className="form-group fv-plugins-icon-container">
              <input
                placeholder="Email"
                type="email"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "email"
                )}`}
                name="email"
                {...formik.getFieldProps("email")}
              />
              {formik.touched.email && formik.errors.email ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.email}</div>
                </div>
              ) : null}
            </div>
            <div className="form-group d-flex flex-wrap flex-center">
              <button
                id="kt_login_forgot_submit"
                type="submit"
                className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                disabled={formik.isSubmitting}
              >
                {!formik.isSubmitting && <span>Gönder</span>}
                {
                  formik.isSubmitting && 
                  <>
                    <span>Gönderiliyor</span>
                    <span className="ml-3 spinner spinner-white"></span>
                  </>
                }
              </button>
              <Link to="/auth">
                <button
                  type="button"
                  id="kt_login_forgot_cancel"
                  className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
                >
                  Geri
                </button>
              </Link>
            </div>
          </form>
        </div>
      )}
    </>
  );
}